import React, { useState } from 'react';
import Menu from 'react-burger-menu/lib/menus/slide';
import { AiOutlinePhone } from 'react-icons/ai';
import { BsInstagram } from 'react-icons/bs';
import { FiYoutube } from 'react-icons/fi';
import { GoLocation } from 'react-icons/go';
import { Link } from 'react-router-dom';

var styles = {
  bmBurgerButton: {
    position: 'fixed',
    width: '40px',
    height: '35px',
    right: '10vw',
    bottom: '12px',
  },
  bmBurgerBars: {
    background: '#f00',
    borderRadius: '3px',
    height: '4px',
  },
  bmBurgerBarsHover: {
    background: '#a90000',
  },
  bmCrossButton: {
    height: '24px',
    width: '24px',
  },
  bmCross: {
    background: '#bdc3c7',
  },
  bmMenuWrap: {
    position: 'fixed',
    top: '0',
    height: '100%',
  },
  bmMenu: {
    background: '#111111',
    padding: '2.5em 1.5em 0',
    fontSize: '1.15em',
  },
  bmMorphShape: {
    fill: '#373a47',
  },
  bmItemList: {
    color: '#b8b7ad',
    padding: '0.8em',
  },
  bmItem: {
    display: 'block',
    color: '#fff',
    textDecoration: 'none',
    fontVariant: 'small-caps',
  },
  bmOverlay: {
    top: '0',
    background: 'rgba(0, 0, 0, 0.3)',
  },
};

const Navbar = () => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const showSettings = (event) => {
    event.preventDefault();
  };

  const handleStateChange = () => {
    setMenuIsOpen();
  };

  const closeMenu = () => {
    setMenuIsOpen(false);
  };

  return (
    <>
      <nav className="top-bar-social">
        <a
          href="https://www.instagram.com/crc_dnepr/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <BsInstagram />
        </a>
        <a
          href="https://www.youtube.com/c/CRCMotorsport"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FiYoutube />
        </a>
        <a href="tel:+380668844588">
          <AiOutlinePhone />
        </a>
        <a
          href="https://www.google.com/maps/place/CRC+(Chip+Racing+Club)/@48.3945607,34.9968574,17z/data=!3m1!4b1!4m5!3m4!1s0x40dbfb32241fed03:0x80fd9b270f50ad1a!8m2!3d48.3945607!4d34.9990461"
          target="_blank"
          rel="noopener noreferrer"
        >
          <GoLocation />
        </a>
      </nav>
      <Menu
        isOpen={menuIsOpen}
        onStateChange={handleStateChange}
        right
        width={250}
        styles={styles}
        burgerButtonClassName={'burger-btn'}
      >
        <Link to="/main" onClick={closeMenu} className="menu-item">
          главная
        </Link>
        <Link to="/qualification" onClick={closeMenu} className="menu-item">
          квалификация
        </Link>
        <a
          href="https://drive.google.com/file/d/1qBFPn0cX07aJt3dIQUxU7syrhPquhTGv/view"
          onClick={closeMenu}
          target="_blank"
        >
          регламент
        </a>
        <br />
        <hr />
        <Link to="/pro" onClick={closeMenu} className="menu-item">
          - pro
        </Link>
        <Link to="/sport" onClick={closeMenu} className="menu-item">
          - sport
        </Link>
        <Link to="/street" onClick={closeMenu} className="menu-item">
          - street
        </Link>
      </Menu>
    </>
  );
};

export default Navbar;
